export default "/react/logoKillbot-10e250fc.png";